export const catalogSortOptions = [
  { value: "popularity", label: "Sort by Popularity" },
  { value: "name", label: "Sort by Name" },
  { value: "price_low", label: "Price: Low to High" },
  { value: "price_high", label: "Price: High to Low" },
];

const designFaqs = [
  {
    question: "What types of graphic design services do you offer?",
    answer:
      "Our graphic design services include: Logo design and branding, Social media graphics and posts, Brochures, flyers, and catalogs, Packaging design, Posters, banners, and hoardings, Motion graphics and animated invitations.",
  },
  {
    question: "Can you create custom designs tailored to my brand?",
    answer:
      "Yes, all our designs are customized to align with your brand's style, colors, and objectives. We ensure that the designs reflect your brand identity.",
  },
  {
    question: "Do you design for both print and digital platforms?",
    answer:
      "Absolutely! We create designs for both digital platforms (social media, websites, email campaigns) and print media (brochures, banners, packaging).",
  },
];

const marketingFaqs = [
  {
    question: "What types of marketing and promotion services do you offer?",
    answer:
      "Our marketing and promotion services include campaign creatives, promotional collateral, brand visibility assets, social media promotion designs, retail branding support, and custom communication materials.",
  },
  {
    question: "Can you create custom promotional assets for my brand?",
    answer:
      "Yes, every marketing and promotion service can be aligned to your brand identity, campaign objective, target audience, and preferred channels.",
  },
  {
    question: "Do you support both digital and offline promotion needs?",
    answer:
      "Absolutely. We handle assets for digital channels like social media and online campaigns, along with offline promotion needs such as flyers, posters, standees, and retail branding materials.",
  },
];

const designReachOut = {
  title: "Work as a Designer with Indorinama",
  description:
    "Work from anywhere, anytime.\nJoin our creative team of designers.",
  formFields: [
    { name: "name", label: "Your Name", type: "text", required: true },
    { name: "mobile", label: "Mobile No.", type: "tel", required: true },
    { name: "email", label: "Email ID", type: "email", required: true },
    { name: "city", label: "City", type: "text", required: true },
    {
      name: "workPreference",
      label: "Work Preference",
      type: "select",
      options: ["Full-Time", "Part-Time", "Freelancer"],
      required: true,
    },
  ],
};

const marketingReachOut = {
  title: "Work on Marketing Solutions Projects with Indorinama",
  description:
    "Work from anywhere, anytime.\nJoin our creative and campaign execution network.",
  formFields: [
    { name: "name", label: "Your Name", type: "text", required: true },
    { name: "mobile", label: "Mobile No.", type: "tel", required: true },
    { name: "email", label: "Email ID", type: "email", required: true },
    { name: "city", label: "City", type: "text", required: true },
    {
      name: "workPreference",
      label: "Work Preference",
      type: "select",
      options: ["Full-Time", "Part-Time", "Freelancer"],
      required: true,
    },
  ],
};

const getPriceSortState = (sortBy) =>
  sortBy === "price_low" || sortBy === "price_high";

export const designingCatalogConfig = {
  category: "designing",
  endpoint: "/api/designing",
  cardIdPrefix: "design",
  headerCategory: "designing",
  videosCategory: "design",
  clientsCategory: "design",
  searchPlaceholder: "Search designing services",
  emptyMessage: (searchTerm) =>
    searchTerm ? `No designs found for "${searchTerm}"` : "No designs found",
  showFilterOptions: false,
  faqItems: designFaqs,
  reachOut: designReachOut,
  getFilterOptions: (items) => {
    const collections = [
      "All",
      ...new Set(
        items
          .filter((item) => item?.collection)
          .map((item) => item.collection),
      ),
    ];
    const sizes = [
      "All",
      ...new Set(items.filter((item) => item?.size).map((item) => item.size)),
    ];

    return {
      collection: collections,
      size: sizes,
    };
  },
  updateFilters: (previousFilters, filterType, value) => ({
    ...previousFilters,
    [filterType]: value === "All" ? null : value,
  }),
  filterVisibleItems: (items, selectedFilters) =>
    items.filter((item) => {
      if (!item) return false;

      return Object.entries(selectedFilters).every(([filterType, filterValue]) => {
        if (!filterValue) return true;

        switch (filterType) {
          case "collection":
            return item.collection === filterValue;
          case "size":
            return item.size === filterValue;
          case "category":
            return item.category === filterValue;
          case "type":
            return item.type === filterValue;
          default:
            return true;
        }
      });
    }),
  buildQueryParams: ({ page, limit, sortBy, searchTerm, selectedFilters }) => {
    const isPriceSort = getPriceSortState(sortBy);
    let sortParam = "order,title";

    if (sortBy === "name") {
      sortParam = "title";
    }

    const params = new URLSearchParams({
      page: String(isPriceSort ? 1 : page),
      limit: String(isPriceSort ? 500 : limit),
      sort: sortParam,
    });

    let filterIndex = 0;

    // Filter for enabled items only
    params.append(`where[and][${filterIndex}][enabled][not_equals]`, "false");
    filterIndex += 1;

    if (searchTerm) {
      params.append(`where[and][${filterIndex}][title][like]`, searchTerm);
      filterIndex += 1;
    }

    if (selectedFilters?.type) {
      params.append(`where[and][${filterIndex}][type][equals]`, selectedFilters.type);
      filterIndex += 1;
    }

    params.append('select[sub_description]', 'false');
    params.append('select[hero_media]', 'false');
    params.append('select[relatedOptions]', 'false');
    // params.append('select[youtube]', 'false');

    return { params, isPriceSort };
  },
};

export const printingCatalogConfig = {
  category: "printing",
  endpoint: "/api/printing",
  cardIdPrefix: "marketing",
  headerCategory: "printing",
  videosCategory: "printing",
  clientsCategory: "printing",
  searchPlaceholder: "Search marketing solutions services",
  emptyMessage: (searchTerm) =>
    searchTerm
      ? `No marketing solutions services found for "${searchTerm}"`
      : "No marketing solutions services found",
  showFilterOptions: true,
  faqItems: marketingFaqs,
  reachOut: marketingReachOut,
  getFilterOptions: async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://api.indorinama.com'}/api/marketing-categories?sort=order`);
      const data = await response.json();
      const categories = data.docs?.map(doc => doc.name) || [];
      return {
        ...(categories.length > 0 ? { categories } : {}),
      };
    } catch (error) {
      console.error('Error fetching marketing categories:', error);
      return {};
    }
  },
  updateFilters: (previousFilters, filterType, values) => ({
    ...previousFilters,
    [filterType]:
      values === "All"
        ? null
        : Array.isArray(values)
          ? values.filter(Boolean)
          : values,
  }),
  filterVisibleItems: (items, selectedFilters) =>
    items.filter((item) => {
      if (!item) return false;

      return Object.entries(selectedFilters).every(
        ([filterType, filterValues]) => {
          if (!filterValues || (Array.isArray(filterValues) && filterValues.length === 0)) {
            return true;
          }

          if (filterType === "type") {
            return item.type === filterValues;
          }

          if (filterType === "categories") {
            const itemCategories = item.categories?.map(c => 
              typeof c === 'string' ? c : c.name
            ) || [];
            return filterValues.some(filterValue => 
              itemCategories.includes(filterValue)
            );
          }

          if (Array.isArray(filterValues)) {
            return filterValues.some(
              (filterValue) => item?.[filterType] === filterValue,
            );
          }

          return item?.[filterType] === filterValues;
        },
      );
    }),
  buildQueryParams: ({ page, limit, sortBy, searchTerm, selectedFilters }) => {
    const isPriceSort = getPriceSortState(sortBy);
    let sortParam = "order,title";

    if (sortBy === "name") {
      sortParam = "title";
    }

    const params = new URLSearchParams({
      page: String(isPriceSort ? 1 : page),
      limit: String(isPriceSort ? 500 : limit),
      sort: sortParam,
    });

    let filterIndex = 0;

    // Filter for enabled items only
    params.append(`where[and][${filterIndex}][enabled][not_equals]`, "false");
    filterIndex += 1;

    if (searchTerm) {
      params.append(`where[and][${filterIndex}][title][like]`, searchTerm);
      filterIndex += 1;
    }

    if (selectedFilters.categories?.length > 0) {
      const categoryIds = selectedFilters.categories.join(",");
      params.append(`where[and][${filterIndex}][categories][in]`, categoryIds);
      filterIndex += 1;
    }

    if (selectedFilters?.type) {
      params.append(`where[and][${filterIndex}][type][equals]`, selectedFilters.type);
      filterIndex += 1;
    }

    ["category", "format"].forEach((field) => {
      const values = selectedFilters[field];
      if (Array.isArray(values) && values.length > 0) {
        params.append(
          `where[and][${filterIndex}][${field}][in]`,
          values.join(","),
        );
        filterIndex += 1;
      }
    });

    params.append('select[sub_description]', 'false');
    params.append('select[hero_media]', 'false');
    params.append('select[relatedOptions]', 'false');
    // params.append('select[youtube]', 'false');
    // params.append('select[brochure]', 'false');

    return { params, isPriceSort };
  },
};
